import { type ConversationTechnicalMessage } from '../../value-objects/ConversationTechnicalMessage'
import {
  CONVERSATION_TECHNICAL_MESSAGE_VERSION,
  type ConversationTechnicalMessageApiModel,
} from '../api-models/ConversationTechnicalMessageApiModel'

export const mapConversationTechnicalMessage = (
  technicalMessage: ConversationTechnicalMessage
): string => {
  const apiModel: ConversationTechnicalMessageApiModel = {
    technical_message: {
      version: CONVERSATION_TECHNICAL_MESSAGE_VERSION,
      action: technicalMessage.action,
      params: { item_id: technicalMessage.params.itemId },
    },
  }
  return JSON.stringify(apiModel)
}
